import { NgModule } from '@angular/core';

import { SubmitButtonDirective } from './submit-button.directive';

@NgModule({
    exports: [SubmitButtonDirective],
    declarations: [SubmitButtonDirective]
})
export class SubmitButtonModule { }
